import { isVertical } from './layout.js';
import type { Point } from '../../core/types/point.js';
import type { Layout } from '../types/categorical-bar-chart.js';

/**
 * Returns the "from" and "to" coordinates for the zero line in a categorical bar chart
 * considering the layout, the zero coordinate and chart dimensions.
 * It also returns whereas to "show" or not the line
 *
 * @param layout -
 * @param zeroLineValue -
 * @param chartWidth -
 * @param chartHeight -
 */
export function buildZeroLine(
  layout: Layout,
  zeroLineValue: number,
  chartWidth: number,
  chartHeight: number,
) {
  let from: Point, to: Point, show: boolean;

  if (isVertical(layout)) {
    show = zeroLineValue <= chartHeight;
    from = { x: 0, y: zeroLineValue };
    to = {
      x: chartWidth,
      y: zeroLineValue,
    };
  } else {
    show = zeroLineValue >= 0;
    from = { x: zeroLineValue, y: 0 };
    to = {
      x: zeroLineValue,
      y: chartHeight,
    };
  }

  return {
    show,
    from,
    to,
  };
}
